import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { toast } from "react-toastify";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { useLanguageContext } from "../../../Context/LanguageContext";
import Tooltip from "@mui/material/Tooltip";
import EquipmentActions from "../../../Actions/EquipmentActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useEffect } from "react";
import TabsActions from "../../../Actions/TabsActions";
import tabsStore from "../../../Stores/TabsStore";
import tabsConstants from "../../../Constants/TabsConstants";
import equipmentStore from "../../../Stores/EquipmentStore";
import EquipmentContants from "../../../Constants/EquipmentConstants";

export default function ScrapImageList({
  isOpen,
  setOpenScrapImageListView,
  equpId,
}) {
  const [open, setOpen] = React.useState(isOpen);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [imageData, setImageData] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [isImageShow, setIsImageShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  useEffect(() => {
    setGlobalSpinner(true);
    EquipmentActions.getEquipmentScrapPhotos(equpId);
    return () => {};
  }, [equpId]);

  const handleClose = () => {
    setOpen(false);
    setOpenScrapImageListView(false);
  };

  const handleShow = (item) => {
    setGlobalSpinner(true);
    TabsActions.getDocumentAsByte(item.id, item.name);
  };

  function handleLightBox(e, _value) {
    e.preventDefault();
    setSelectedImage(_value);
    setIsImageShow(true);
  }

  useEffect(() => {
    function downloadDocumentSuccess() {
      var _details = tabsStore.getResult();
      setGlobalSpinner(false);
    }

    function downloadDocumentFailure() {
      var res = tabsStore.getResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
      downloadDocumentSuccess
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
      downloadDocumentFailure
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
        downloadDocumentSuccess
      );

      tabsStore.removeChangeListener(
        tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
        downloadDocumentFailure
      );
    };
  }, []);

  useEffect(() => {
    function getEquipmentScrapImagesSuccess() {
      var _details = equipmentStore.getEquipmentScrapImagesRes();
      if (_details && _details.length > 0) {
        setImageData(_details);
      }
      setGlobalSpinner(false);
    }

    function getEquipmentScrapImagesFailure() {
      var res = equipmentStore.getEquipmentScrapImagesRes();
      setGlobalSpinner(false);
      toast.error(localization.fileDownloadError);
    }

    equipmentStore.addChangeListener(
      EquipmentContants.GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS,
      getEquipmentScrapImagesSuccess
    );

    equipmentStore.addChangeListener(
      EquipmentContants.GET_EQUIPMENT_SCRAP_IMAGES_FAILURE,
      getEquipmentScrapImagesFailure
    );

    return () => {
      equipmentStore.removeChangeListener(
        EquipmentContants.GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS,
        getEquipmentScrapImagesSuccess
      );

      equipmentStore.removeChangeListener(
        EquipmentContants.GET_EQUIPMENT_SCRAP_IMAGES_FAILURE,
        getEquipmentScrapImagesFailure
      );
    };
  }, []);

  useEffect(() => {
    let image = [];

    if (imageData !== null && imageData !== undefined) {
      imageData.map((item, index) => {
        if (item.documentAsString) {
          image.push(`data:image/jpg;base64,${item.documentAsString}`);
        }
      });
      setImageSrc(image);
    } else {
      setImageSrc(null);
    }
  }, [imageData]);

  function BasicTable() {
    return (
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className="simpleListTable"
        >
          <TableHead>
            <TableRow>
              <TableCell>{localization.preview}</TableCell>
              <TableCell align="left">{localization.name}</TableCell>
              <TableCell align="left">{localization.actions}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {imageData.map((row, index) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">
                  <img
                    src={"data:image/jpg;base64," + row.documentAsString}
                    alt={""}
                    className="thumbnailPreview"
                    loading="lazy"
                    style={{ width: "100px" }}
                    onClick={(e) => handleLightBox(e, index)}
                  />
                </TableCell>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">
                  <Tooltip title={localization.download}>
                    <CloudDownloadOutlinedIcon
                      className="generalIconCls mr-3"
                      onClick={() => {
                        handleShow(row);
                      }}
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={"md"}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{localization.scrapImages}</DialogTitle>
          <DialogContent dividers>
            <div>
              <BasicTable />
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size="large" onClick={handleClose}>
              {localization.close}
            </Button>
          </DialogActions>
        </Dialog>
        {isImageShow &&
          (imageSrc.length === 1 ? (
            <Lightbox
              allowReset={true}
              onClose={() => {
                setIsImageShow(false);
              }}
              image={imageSrc[0]}
            ></Lightbox>
          ) : (
            <Lightbox
              allowReset={true}
              onClose={() => {
                setIsImageShow(false);
              }}
              images={imageSrc}
              startIndex={selectedImage}
            ></Lightbox>
          ))}
      </React.Fragment>
    </>
  );
}
